import { GammaDialog } from '@factorialco/deprecated-design-system'

import CrashLogo from 'modules/core/components/CrashLogo'
import ErrorBoundary from 'modules/core/components/ErrorBoundary'
import Form from 'modules/core/components/Form'

type ModalProps = React.ComponentProps<typeof GammaDialog>

type Props = Omit<ModalProps, 'Form' | 'ErrorBoundary' | 'errorContent'>

const Dialog = (props: Props) => (
  <GammaDialog
    {...props}
    Form={Form}
    ErrorBoundary={ErrorBoundary}
    errorContent={<CrashLogo compact />}
  />
)

export default Dialog
